import React from "react"
import { firestore } from "../core"
import { useRecommendedUsers } from "popopo-lib-front/firestore-access"
import { Spinner } from "react-bootstrap"
import { NavLink } from "react-router-dom"
import { Paths } from "../paths"
import { UserId } from "popopo-msg"

export const RecommendedUsers = () => {
  const recommendedUsers = useRecommendedUsers(firestore)

  if (recommendedUsers === "loading") {
    return <Spinner/>
  }

  const sortedUsers = [...recommendedUsers].sort((a, b) => b.created_at - a.created_at)

  return (<>
    <div className="row mt-5 gy-5 justify-content-center">
      <h2>フォローしませんかユーザー</h2>
      <div className="row row-cols-1 row-cols-md-3 g-4">
        {sortedUsers.map(user => (
          <div className="col" key={user.id}>
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">
                  <NavLink to={Paths.users.user.getPath(UserId(user.user_id))}>
                    {user.user_id}
                  </NavLink>
                </h5>
              </div>
              <div className="card-footer">
                <small className="text-muted">追加日時: {new Date(user.created_at).toLocaleString()}</small>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>

  </>)
}
